module.exports = __webpack_public_path__ + "static/media/blingV3_15.82bcbe7d.png";